const todayDate = () => {
  const today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;

  return `${year}-${month}-${day}`;
};

const dayPlusOne = () => {
  const today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate() + 1;

  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;

  return `${year}-${month}-${day}`;
};

const dayPlusTwenty = () => {
  const days = [];

  for (var i = 1; i <= 20; i++) {
    const today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + i;
    let day = today.getDate() + i;

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    days.push(`${year}-${month}-${day}`);
  }

  return days;
};

const reverseDate = (date) => {
  return date?.split("-").reverse().join("/");
};

function getNext20Days(includeToday = false) {
  const today = new Date();
  const next20Days = [];

  const monthNamesEnglish = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  const monthNamesFrench = [
    "Janv",
    "Févr",
    "Mars",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc"
  ];

  const dayOfWeekEnglish = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayOfWeekFrench = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

  const startDay = includeToday ? 0 : 1;

  for (let i = startDay; i <= 20; i++) {
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + i);

    const day = String(nextDate.getDate()).padStart(2, "0");
    const monthIndex = nextDate.getMonth() + 1;
    const year = nextDate.getFullYear();
    const monthFix = monthIndex < 10 ? `0${monthIndex}` : monthIndex;

    const monthTextEnglish = monthNamesEnglish[monthIndex - 1];
    const monthTextFrench = monthNamesFrench[monthIndex - 1];

    const dayOfWeekIndex = nextDate.getDay();
    const dayTextEnglish = dayOfWeekEnglish[dayOfWeekIndex];
    const dayTextFrench = dayOfWeekFrench[dayOfWeekIndex];
    next20Days.push({
      day,
      month: monthFix,
      year,
      dayLong: year + "-" + monthFix + "-" + day,
      dayTextEnglish,
      dayTextFrench,
      monthTextEnglish: monthTextEnglish,
      monthTextFrench: monthTextFrench
    });
  }

  return next20Days;
}

function hasPassed15Minutes(createdAt) {
  // Convert createdAt to a Date object
  const createdAtDate = new Date(createdAt);

  // Calculate the difference in milliseconds between createdAt and the current time
  const timeDifference = new Date() - createdAtDate;

  // Check if the time difference is greater than 15 minutes (900,000 milliseconds)
  return timeDifference > 900000; // 15 minutes in milliseconds
}

export {
  dayPlusOne,
  dayPlusTwenty,
  getNext20Days,
  hasPassed15Minutes,
  reverseDate,
  todayDate
};
